// extracted by mini-css-extract-plugin
export default {"large":"spinner_large__dQdUE","medium":"spinner_medium__EYStv"};